(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-timeline"] && !Shopify.designMode) return;
  try {
    
  function initCustomTimeline() {
    var blocks = document.querySelectorAll('.custom-timeline__entry');

    if ('IntersectionObserver' in window && !Shopify.designMode) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var icon = entry.target.querySelector('.custom-timeline__icon');
          var content = entry.target.querySelector('.custom-timeline__content');

          if (entry.isIntersecting) {
            icon.classList.add('is-visible');
            content.classList.add('is-visible');
          } else {
            icon.classList.remove('is-visible');
            content.classList.remove('is-visible');
          }
        });
      }, {
        rootMargin: '0px 0px -50px 0px',
        threshold: 0
      });

      blocks.forEach(function(block) {
        observer.observe(block);
      });
    } else {
      blocks.forEach(function(block) {
        var icon = block.querySelector('.custom-timeline__icon');
        var content = block.querySelector('.custom-timeline__content');
        icon.classList.add('is-visible');
        content.classList.add('is-visible');
      });
    }
  }

  initCustomTimeline();

  document.addEventListener('shopify:section:load', initCustomTimeline);
  document.addEventListener('shopify:block:select', initCustomTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
